import formValidation from 'formvalidation/es6/core/Core';
import Bootstrap3 from 'formvalidation/es6/plugins/Bootstrap3';
import DefaultSubmit from 'formvalidation/es6/plugins/DefaultSubmit';
import SubmitButton from 'formvalidation/es6/plugins/SubmitButton';
import Declarative from 'formvalidation/es6/plugins/Declarative';
import Trigger from 'formvalidation/es6/plugins/Trigger';
import Recaptcha from 'formvalidation/es6/plugins/Recaptcha';
import "es6-shim";
import scrollToElement from 'scroll-to-element';

(function ready(fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}(() => {
    /*
        By Osvaldas Valutis, www.osvaldas.info
        Available for use under the MIT License
    */

    (function (document, window, index) {
        const inputs = document.querySelectorAll('input[type=file]');
        Array.prototype.forEach.call(inputs, (input) => {
            const label = input.parentNode;
            const reset = label.querySelector('#reset');
            const choose = label.querySelector('span').innerHTML;
            input.addEventListener('change', (e) => {
                let fileName = '';
                fileName = e.target.value.split('\\').pop();
                if (fileName) {
                    label.querySelector('span').innerHTML = fileName;
                    label.classList.add('not-empty');
                }
            });
            reset.addEventListener('click', (e) => {
                // e.stopPropagation();
                e.preventDefault();
                input.value = '';
                label.querySelector('span').innerHTML = choose;
                label.classList.remove('not-empty');
            });

            // Firefox bug fix
            input.addEventListener('focus', () => {
                input.classList.add('has-focus');
            });
            input.addEventListener('blur', () => {
                input.classList.remove('has-focus');
            });
        });
    }(document, window, 0));
    if (document.querySelector('.apply form')) {
        const fv = formValidation(document.querySelector('form'), {
            plugins: {
                trigger: new Trigger({
                    event: {
                        'nonProfit[organization]': 'blur',
                        'nonProfit[email]': 'blur',
                        'nonProfit[country]': 'blur',
                    },
                }),
                bootstrap3: new Bootstrap3(),
                defaultSubmit: new DefaultSubmit(),
                submitButton: new SubmitButton(),
                declarative: new Declarative({
                    html5Input: true,
                }),
                recaptcha: new Recaptcha({
                    element: 'captchaContainer',
                    siteKey: process.env.INVISIBLE_RECAPTCHA_SITE_KEY,
                    message: JSON.parse(document.querySelector('#json_translations').innerHTML).reCaptchaErrorMessage,
                    size: 'invisible',
                }),
            },
        });
    }

    [].forEach.call(document.querySelectorAll('label[data-anchor]'), (anchor) => {
        anchor.addEventListener('click', (e) => {
            if (typeof (anchor) !== 'undefined' && anchor != null) {
                scrollToElement(document.querySelector('.apply'), {
                    offset: -50,
                    duration: 500,
                });
            }
        });
    });
}));
